import moment from "moment";

export default function DemoCard({ item, isDollar }) {
  const isSauda = item.type === "REMOVE" || item.type === "SQ.OFF";

  const pl = Number(item.profit_loss);
  const plColor = pl > 0 ? "var(--buymeta)" : "var(--sellmeta)";

  return (
    <div
      className="
        grid grid-cols-12 items-center
        px-3 py-2 border-b border-[var(--hover)]
        hover:bg-[var(--cardhover)] transition-all
        text-[13px] select-none
      "
    >
      {/* SYMBOL (Col 1-3) */}
      <div className="col-span-3 flex flex-col">
        <span className="font-semibold text-[14px] text-[var(--text)] leading-tight">
          {item.symbol}
        </span>

        <span className="text-[10px] text-[var(--subtext)] leading-tight">
          {item.script_type === "nse_cash"
            ? "Equity"
            : moment(item.expiry_date).format("DD-MMM")}
        </span>
      </div>

      {/* BUY/SELL + QTY (Col 4) */}
      <div className="col-span-2 flex flex-col pl-2">
        <span
          className={`font-semibold ${
            item.buy_sell === 0
              ? "text-[var(--buymeta)]"
              : "text-[var(--sellmeta)]"
          }`}
        >
          {item.buy_sell === 0 ? "BUY" : "SELL"}
        </span>

        <span className="text-[11px] text-[var(--subtext)]">
          {item.qty} qty
        </span>
      </div>

      {/* PRICE SECTION (Col 5-7) */}
      <div className="col-span-3 flex flex-col pl-2">
        {isSauda ? (
          <>
            <span className="text-[var(--subtext)] text-[12px]">
              {item.standing_rate} →{" "}
              <span className="font-semibold text-[var(--text)]">
                {item.rate}
              </span>
            </span>
          </>
        ) : (
          <span className="font-semibold text-[var(--text)]">{item.rate}</span>
        )}

        <span className="text-[10px] text-[var(--subtext)]">
          {moment(item.date_created).format("DD-MM HH:mm")}
        </span>
      </div>

      {/* P&L (Col 8-12) */}
      <div className="col-span-4 flex flex-col items-end pr-1">
        <span
          className="font-semibold text-[15px] leading-tight"
          style={{ color: plColor }}
        >
          {pl.toFixed(2)} {isDollar === 1 ? "$" : "" }
        </span>

        <span
          className="text-[10px] leading-tight"
          style={{ color: isSauda ? "var(--sellmeta)" : "var(--buymeta)" }}
        >
          {item.type}
        </span>
      </div>
    </div>
  );
}
